import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",  // Blau
    },
    secondary: {
      main: "#d32f2f",  // Rot
    },
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
    h4: {
      fontWeight: 600,
      fontSize: "2rem",
    },
  },
});

export default theme;
